import styled from 'styled-components'
import vars from './vars'

const MessageBubble = styled.div`
  background-color: ${props => props.color || vars.grey7};
  border-radius: 10px;
  padding: 10px;
  max-width: 75%;
  text-align: left;
  
  & img {
    max-width: 100%;
  }
`

export default MessageBubble


// WEBPACK FOOTER //
// ./src/ChatWidget/components/common/MessageBubble.js